import type { GenerateMode } from '@/api/generate.api';

/**
 * The names the generator's `?model=` link carries, one per Toolkit model card. The generator opens the ones it
 * has an entry for in `generate.api` and shows the rest as not available.
 */
export const GENERATOR_MODEL_SLUGS = {
  FLUX_3_IMAGE: 'flux-3-image',
  GPT_IMAGE_2_5_FLARE: 'gpt-image-2-5-flare',
  GPT_IMAGE_2_5_SUNBURST: 'gpt-image-2-5-sunburst',
  IDEOGRAM_V4_5: 'ideogram-v4-5',
  NANO_BANANA_2_1: 'nano-banana-2-1',
  NANO_BANANA_PRO: 'nano-banana-pro',
  NANO_BANANA_2: 'nano-banana-2',
  SEEDANCE_2_5_REFERENCE: 'seedance-2-5-reference',
  SEEDANCE_2_5: 'seedance-2-5',
  SEEDANCE_2_0_REFERENCE: 'seedance-2-0-reference',
  SEEDANCE_2_0_REFERENCE_FAST: 'seedance-2-0-reference-fast',
  SEEDANCE_2_0: 'seedance-2-0',
  SEEDANCE_2_0_FAST: 'seedance-2-0-fast',
  KLING_4_0: 'kling-4-0',
  KLING_4_0_REFERENCE: 'kling-4-0-reference',
  KLING_3_0_STANDARD: 'kling-3-0-standard',
  KLING_3_0_PRO: 'kling-3-0-pro',
  KLING_3_0_4K: 'kling-3-0-4k',
} as const;

export type GeneratorModelSlug =
  | 'flux-3-image'
  | 'gpt-image-2-5-flare'
  | 'gpt-image-2-5-sunburst'
  | 'ideogram-v4-5'
  | 'nano-banana-2-1'
  | 'nano-banana-pro'
  | 'nano-banana-2'
  | 'seedance-2-5-reference'
  | 'seedance-2-5'
  | 'seedance-2-0-reference'
  | 'seedance-2-0-reference-fast'
  | 'seedance-2-0'
  | 'seedance-2-0-fast'
  | 'kling-4-0'
  | 'kling-4-0-reference'
  | 'kling-3-0-standard'
  | 'kling-3-0-pro'
  | 'kling-3-0-4k';

/**
 * The model each media type opens with, from the Toolkit's Images and Videos cards, the Image / Video switch, and a
 * link with no model.
 */
export const DEFAULT_GENERATOR_MODEL_SLUGS: Readonly<Record<GenerateMode, GeneratorModelSlug>> = {
  image: GENERATOR_MODEL_SLUGS.NANO_BANANA_PRO,
  video: GENERATOR_MODEL_SLUGS.SEEDANCE_2_5,
};
